import { Select, MenuItem, FormControl, InputLabel, FormHelperText, Box, Chip, Checkbox, ListItemText } from "@mui/material";
import { useFormContext } from "../form/IForm";
import { useConfig } from "../store/selectors/useConfig";

const IMultiSelect = ({
  model,
  label,
  lookup = null,
  options = [],
  variant = "outlined",
  displayLabel = true,
  ...rest
}) => {
  const form = useFormContext();
  const { getLookupValues } = useConfig();
  const opts = getLookupValues(lookup) || options || [];
  const raw = form?.values[model];
  const selected = Array.isArray(raw) ? raw : [];
  const labelOf = (key) => opts.find((o) => o.key === key)?.value || key;

  return (
    <FormControl
      size="small"
      variant={variant}
      fullWidth
      error={form.touched[model] && Boolean(form.errors[model])}
    >
      {displayLabel && <InputLabel>{label}</InputLabel>}
      <Select
        multiple
        value={selected}
        onChange={(e) => form?.setFieldValue(model, e.target.value)}
        onBlur={form?.handleBlur}
        name={model}
        label={displayLabel ? label : ""}
        renderValue={(picked) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {picked.map((key) => (
              <Chip key={key} size="small" label={labelOf(key)} />
            ))}
          </Box>
        )}
        {...rest}
      >
        {(opts || []).map((option) => (
          <MenuItem key={option.key} value={option.key}>
            <Checkbox size="small" checked={selected.indexOf(option.key) > -1} sx={{ py: 0 }} />
            <ListItemText primary={option.value} />
          </MenuItem>
        ))}
      </Select>
      {form.touched[model] && form.errors[model] && (
        <FormHelperText>{form.errors[model]}</FormHelperText>
      )}
    </FormControl>
  );
};

export default IMultiSelect;
